import { useSelector } from "react-redux";
import { StoreData } from "..";

export const useAppOrigin = () => {
  return useSelector((state: StoreData) => state.appContext.origin);
};
